module.exports = __webpack_public_path__ + "static/scale-model-of-wingman-adventures-in-hialeah-florida-16216f37b6e990e7549a08c5cf29ad47.png";